import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
    Button,
    Card,
    CardBody,
    Col,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import breadcrumbs from "../../common/Breadcrumbs"
import { Link, useLocation } from "react-router-dom"
import SendMessageTable from "./SendMessageTable"
import { dateFormat, dateTimeFormatIOS } from "pages/Common"
import axios from "axios"
import appConfig from "Api/app.config"
import Dropzone from "react-dropzone";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import DeleteModel from "common/deleteModel/deleteModel"
import ErrorModel from "common/errorModel/errorModel"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

let Date1 = new Date()
const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

function SendMessage() {
    const { getApi, postApi, deleteApi, putApi } = useApi()
    document.title = `SOP | Raja Rani Couture`
    let { pathname } = useLocation()

    // useStates
    const [tableData, setTableData] = useState([])
    const [totalRecords, setTotalRecords] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [modal, setModal] = useState(false)
    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    const [date, setdate] = useState(dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))
    const [editDate, setEditDate] = useState(dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [userControls, setUserControls] = useState([])
    const [selectedUser, setSelectedUser] = useState([])
    const [usererror, setUserError] = useState(false)
    const [message, setMessgae] = useState('')
    const [oldUrl, setOldUrl] = useState('')
    const [isMessgae, setIsMessage] = useState(true)
    const [isMessgaeError, setIsMessageError] = useState(false)
    const [messageId, setMessgaeId] = useState(0)
    const [remarkModel, setRemarkModel] = useState(false)
    const [remark, setRemark] = useState('')
    const [RoleId, setRoleId] = useState(
        (JSON.parse(localStorage?.getItem("authUser")).RoleId)
    )
    const [addRemarkModel, setAddRemarkModel] = useState(false)
    const [isRemarkError, setIsRemarkError] = useState(false)
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(true)
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [name, setName] = useState('')

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                // options.unshift({
                //     label: "Select user",
                //     value: 0,
                // });
                // setSelectedUser({
                //     label: "Select user",
                //     value: 0,
                // });
                setUserControls(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    // send messgae list api
    const sendMessgaeApi = () => {
        setIsLoading(true)
        postApi("Common/share-message/list", {
            userId: userFilter,
            displayStart: 1,
            pageSize: 100000,
            searchText: '',
            sortColumn: "",
            sortOrder: "asc",
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data.ShareMessageList)
                setTotalRecords(data.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            // setScreenLoad(false)
        })
    }

    // send messgae list api useEffect
    useEffect(() => {
        sendMessgaeApi()
    }, [dateFilter, dateDisble, userFilter, addRemarkModel])

    const handleDelete = Id => {
        setScreenLoad(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this share message permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Common/share-message/delete?id=${Id}`).then(
                        async ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Sucessfully deleted", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Message",
                                    text: data,
                                })
                            }
                            setScreenLoad(false)
                        }
                    )
                } else {
                    setScreenLoad(false)
                }
            })
        }
    }

    const remarkToggle = () => {
        setRemarkModel(!remarkModel)
    }

    const handleRemark = (remark) => {
        setRemark(remark)
        remarkToggle()
    }

    const addRemarkToggle = () => {
        setAddRemarkModel(!addRemarkModel)
        setIsRemarkError(false)
    }

    const handleSwitch = (id, IsView, e) => {
        if (id) {
            setMessgaeId(id)
            addRemarkToggle()
        }
    }

    const hadleSubmitRemark = () => {
        if (remark == '') {
            setIsRemarkError(true)
        } else {
            setIsRemarkError(false)
            setformSumitLoading(true)
            putApi("Common/share-message/isView", { id: parseInt(messageId), Remark: remark }).then(({ data, status }) => {
                if (status === 200) {
                    setformSumitLoading(false)
                    sendMessgaeApi()
                    addRemarkToggle()
                    toast.success("Message sucessfully changed", {
                        style: {
                            fontSize: "15px",
                        },
                    })
                } else {
                    setformSumitLoading(false)
                    ErrorModel.errormodel({
                        title: "Verify Message",
                        text: data,
                    })
                }
            })
        }


    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Send By",
                accessor: "SendByName",
                width: "15%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.IsView == true
                            ?
                            <div style={{ color: "blue", cursor: "pointer" }}
                                onClick={() => handleRemark(row.original.Remark)}
                            >
                                {row.original.SendByName}
                            </div>
                            :
                            <div>
                                {row.original.SendByName}
                            </div>}
                    </p>
                ),
            },
            {
                Header: "Name",
                accessor: "Name",
                width: "20%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.Name == "" || row.original.Name == null ? "N/A" : row.original.Name}
                    </p>
                ),
            },
            {
                Header: "Message/Document",
                accessor: "Message",
                Cell: ({ row }) => {
                    const message = row.original.Message || '';

                    // Extract filename from URL
                    const getFilenameFromUrl = (url) => {
                        try {
                            const urlObj = new URL(url);
                            return urlObj.pathname.split('/').pop() || url;
                        } catch {
                            return url;
                        }
                    };

                    return (
                        <p className="mb-0">
                            {message.includes('https://') ? (
                                <a
                                    href={message}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary hover:underline"
                                >
                                    {getFilenameFromUrl(message)}
                                </a>
                            ) : (
                                message || 'N/A'
                            )}
                        </p>
                    );
                },
            },
            {
                Header: "Target Date",
                accessor: "TargetDate",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.TargetDate == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(
                                row.original.TargetDate.split("T")[0],
                                "dd/MM/yyyy"
                            )}
                    </p>
                ),
            },
            {
                Header: "Is View",
                accessor: "IsView",
                width: "5%",
                Cell: ({ row }) => (
                    <>
                        {RoleId == 1 ?
                            <p className=" mb-0">
                                {row.original.IsView
                                    ? "Yes"
                                    : "No"
                                }
                            </p>
                            :
                            <FormGroup switch className="d-flex justify-content-center">
                                <Input
                                    type="switch"
                                    id={`IsView_${row.original.Id}`}
                                    disabled={row.original.IsView}
                                    defaultChecked={row.original.IsView}
                                    onClick={e => {
                                        handleSwitch(row.original.Id, row.original.IsView, e)
                                    }}
                                />
                            </FormGroup>
                        }
                    </>
                ),
            },
            {
                Header: "Created By",
                accessor: "CreatedByName",
                width: "15%",
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(
                                row.original.CreatedOn.split("T")[0],
                                "dd/MM/yyyy"
                            )}
                    </p>
                ),
            },
            {
                Header: "Action",
                width: "6%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">

                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEdit(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>

                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    const toggle = () => {
        setModal(!modal)
    }

    const handleSendMessage = () => {
        setIsEdit(false)
        setMessgae('')
        setdate(new Date())
        setEditDate(new Date())
        setSelectedUser([])
        setselectedFiles([])
        setSelectFile([])
        setFileName('')
        setIsMessageError(false)
        toggle()
    }

    const handleEdit = (Data) => {
        setIsEdit(true)
        setMessgaeId(Data.Id)
        setMessgae(Data.Message)
        setOldUrl(Data.Message)
        setName(Data.Name)
        setIsMessageError(false)
        setdate(dateFormat(
            Data?.TargetDate.split("T")[0],
            "dd-MM-yyyy"
        ))
        setEditDate(dateFormat(
            Data?.TargetDate.split("T")[0],
            "dd-MM-yyyy"
        ))
        Date1 = Data?.TargetDate
        setSelectedUser({
            label: Data.SendByName,
            value: Data.SendBy
        })
        toggle()
    }

    const [selectedFiles, setselectedFiles] = useState([]);
    const [FileName, setFileName] = useState('');
    const [selectFile, setSelectFile] = useState([]);
    // function handleAcceptedFiles(files) {
    //     files.map(file =>
    //         Object.assign(file, {
    //             preview: URL.createObjectURL(file),
    //             formattedSize: formatBytes(file.size),
    //         })
    //     )
    //     const reader = new FileReader();
    //                 reader.readAsDataURL(files);
    //                 reader.onloadend = () => {
    //                     const base64data = reader.result;
    //                     resolve(base64data);
    //                 };
    //     setselectedFiles(files)
    // }
    function getFileExtension(filename) {
        // Returns ".pdf" for "png2pdf (2).pdf"
        return filename.slice(filename.lastIndexOf('.'));
    }

    function handleAcceptedFiles(files) {
        setSelectFile(files)
        const promises = files.map(file => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve({
                    ...file,
                    preview: reader.result,
                    formattedSize: formatBytes(file.size),
                    extension: getFileExtension(file.name)
                });
                setFileName(getFileExtension(file.name))
                reader.onerror = (error) => reject(error);
                reader.readAsDataURL(file);
            });
        });

        Promise.all(promises)
            .then(processedFiles => setselectedFiles(processedFiles))
            .catch(error => console.error("Error reading files:", error));
    }

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

    const handleCancle = () => {
        setModal(!modal)
        setIsMessageError(false)
        setdate(new Date())
        setEditDate(new Date())
        setMessgae('')
        setSelectedUser([])
        setselectedFiles([])
        setSelectFile([])
        setFileName('')
    }

    const hadleSubmit = () => {
        if (message == '' && selectedFiles.length == 0) {
            setIsMessageError(true)
        }
        else if (selectedUser.length == 0) {
            setUserError(true)
        } else {
            setUserError(false)
            setIsMessageError(false)
            setformSumitLoading(true)
            isEdit ?
                putApi("Common/share-message/update", {
                    Id: messageId,
                    Message: message,
                    Name: name || '',
                    Document: selectedFiles[0]?.preview?.split(",")[1] || '',
                    SendById: selectedUser?.value,
                    TargetDate: (isEdit && date == editDate) ? Date1 : dateTimeFormatIOS(date),
                    oldUrl: oldUrl || '',
                    FileName: FileName,
                }).then(({ data, status }) => {
                    setformSumitLoading(false)
                    if (status === 200) {
                        toggle()
                        toast.success("Update Sucessfully", {
                            style: {
                                fontSize: "15px",
                            },
                        })
                        sendMessgaeApi()
                        setIsMessageError(false)
                        setdate(new Date())
                        setEditDate(new Date())
                        setMessgae('')
                        setSelectedUser([])
                        setselectedFiles([])
                        setSelectFile([])
                        setFileName('')
                    } else {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    }
                })
                :
                postApi("Common/share-message", {
                    Message: message,
                    Name: name || "",
                    Document: selectedFiles[0]?.preview?.split(",")[1] || '',
                    SendByIds: selectedUser?.map(item => item.value).join(','),
                    TargetDate: dateTimeFormatIOS(date),
                    FileName: FileName,
                }).then(({ data, status }) => {
                    setformSumitLoading(false)
                    if (status === 200) {
                        toggle()
                        sendMessgaeApi()
                        toast.success("Send Sucessfully", {
                            style: {
                                fontSize: "15px",
                            },
                        })
                        setIsMessageError(false)
                        setdate(new Date())
                        setMessgae('')
                        setSelectedUser([])
                        setselectedFiles([])
                        setSelectFile([])
                        setFileName('')
                    } else {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    }
                })
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {isLoading && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].title}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                />
                <Card>
                    <CardBody>
                        <SendMessageTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            customPageSize={10}
                            isLoading={isLoading}
                            handleSendMessage={handleSendMessage}
                            className="custom-header-css"
                            TotalRecords={totalRecords}
                            setDateFilter={setDateFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            dateFilter={dateFilter}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                        />
                    </CardBody>

                    <Modal
                        isOpen={modal}
                        toggle={toggle}
                        centered={true}
                        size=""
                        style={{ width: !isMobile ? "700px" : "" }}
                    >
                        <div className="modal-content">
                            <ModalHeader toggle={toggle} tag="h5">
                                {isEdit ? "Update SOP" : "Create SOP"}
                            </ModalHeader>
                            <ModalBody>
                                <Form>
                                    <Row>
                                        <FormGroup className="mb-2">
                                            <Label htmlFor="validationCustom03">
                                                Name
                                            </Label>
                                            <Input
                                                name="name"
                                                placeholder="Document Name"
                                                type="text"
                                                className="form-control-sm"
                                                onChange={(e) => {
                                                    setName(e.target.value)
                                                }}
                                                value={name}
                                            />
                                        </FormGroup>
                                    </Row>
                                    <Row>

                                        <div>
                                            <div className=" d-flex gap-2 mb-2">
                                                <Input
                                                    type="radio"
                                                    value={true}
                                                    id="message"
                                                    className="form-check-input"
                                                    checked={isMessgae}
                                                    onClick={() => { setIsMessage(true), setselectedFiles([]) }}
                                                />
                                                <Label className="form-check-label font-size-13 me-2" htmlFor="message">
                                                    Message/URL
                                                </Label>
                                                <Input
                                                    type="radio"
                                                    value={false}
                                                    id="document"
                                                    className="form-check-input"
                                                    checked={!isMessgae}
                                                    onClick={() => { setIsMessage(false), setMessgae('') }}
                                                />
                                                <Label className="form-check-label font-size-13" htmlFor="document">
                                                    Upload Docs
                                                </Label>
                                            </div>
                                        </div>
                                        {isMessgae ?
                                            <>
                                                <div className="">
                                                    <Input
                                                        name="message"
                                                        placeholder="Enter Message/URL hear"
                                                        type="textarea"
                                                        rows={4}
                                                        value={message}
                                                        onChange={(e) => { setMessgae(e.target.value), setIsMessageError(false) }}
                                                        className="form-control-sm"
                                                    />
                                                </div>

                                                {isMessgaeError ? (
                                                    <p className="name-required">
                                                        {"Please add detail at least one."}
                                                    </p>
                                                ) : ''}
                                            </>
                                            :
                                            <Row className="mb-1">
                                                <Col md={3}>
                                                    <div title="Upload" style={{ border: "1px solid gray", display: "flex", justifyContent: "center" }}>
                                                        <Dropzone
                                                            onDrop={acceptedFiles => {
                                                                handleAcceptedFiles(acceptedFiles), setIsMessageError(false)
                                                            }}
                                                        >
                                                            {({ getRootProps, getInputProps }) => (
                                                                <div className="" >

                                                                    <div
                                                                        className=" needsclick mt-2"
                                                                        {...getRootProps()}
                                                                    >
                                                                        <input {...getInputProps()} />
                                                                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                                    </div>
                                                                    {/* <div>Upload</div> */}
                                                                </div>
                                                            )}
                                                        </Dropzone>
                                                    </div>
                                                    {isMessgaeError ? (
                                                        <p className="name-required">
                                                            {"Please add detail at least one."}
                                                        </p>
                                                    ) : ''}
                                                </Col>
                                                <Col md={5} style={{ display: "flex", justifyContent: "center" }}>
                                                    {selectFile?.map((f, i) => {
                                                        return (
                                                            <Card
                                                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                                key={i + "-file"}
                                                            >
                                                                <div className="p-2">
                                                                    <Row className="align-items-center">
                                                                        <Col>
                                                                            <Link
                                                                                to="#"
                                                                                className="text-muted font-weight-bold"
                                                                            >
                                                                                {f.name}
                                                                            </Link>
                                                                            {/* <p className="mb-0">
                                                                        <strong>{f.formattedSize}</strong>
                                                                    </p> */}
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Card>
                                                        )
                                                    })}</Col>

                                            </Row>
                                        }

                                    </Row>

                                    <Row className="mt-2">
                                        <Col md={4}>
                                            <FormGroup className="mb-2">
                                                <div>
                                                    <Label htmlFor="FollowupValidation1Custom01" className="required">
                                                        Target Date
                                                    </Label>
                                                    <div className="d-flex date-after" >
                                                        <Flatpickr
                                                            className="form-control d-block flatpicker-date"
                                                            placeholder="dd-MM-yyyy"
                                                            options={{
                                                                // enableTime: true,
                                                                dateFormat: "d-m-Y",
                                                                disableMobile: true
                                                            }}
                                                            value={date}
                                                            onChange={(e) => { setdate(e) }}
                                                        />
                                                    </div>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md={8}>
                                            {isEdit ?
                                                <FormGroup className="mb-2">
                                                    <Label htmlFor="validationCustom03" className="required">
                                                        Send By
                                                    </Label>
                                                    <Select
                                                        unstyled
                                                        styles={usererror ? colourStyles1 : colourStyles}
                                                        value={selectedUser}
                                                        onChange={(e) => {
                                                            setSelectedUser(e)
                                                            setUserError(false)
                                                        }}
                                                        options={userControls}
                                                        className="select2-selection"
                                                    />
                                                    {usererror ? (
                                                        <div className="name-required">
                                                            {"Please select user"}
                                                        </div>
                                                    ) : null}
                                                </FormGroup>
                                                :
                                                <FormGroup className="mb-2">
                                                    <Label htmlFor="validationCustom03" className="required">
                                                        Send By
                                                    </Label>
                                                    <Select
                                                        unstyled
                                                        isMulti
                                                        styles={usererror ? colourStyles1 : colourStyles}
                                                        value={selectedUser}
                                                        onChange={(e) => {
                                                            setSelectedUser(e)
                                                            setUserError(false)
                                                        }}
                                                        options={userControls}
                                                        className="select2-selection"
                                                    />
                                                    {usererror ? (
                                                        <div className="name-required">
                                                            {"Please select user"}
                                                        </div>
                                                    ) : null}
                                                </FormGroup>
                                            }
                                        </Col>
                                    </Row>
                                </Form>

                                <Row>
                                    <div className="text-end mt-2">
                                        <Button
                                            task-title="secondary"
                                            className="btn btn-primary me-2 btn-sm "
                                            color="secondary"
                                            onClick={() => handleCancle()}
                                        >
                                            Cancle
                                        </Button>
                                        {formSumitLoading ? (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                            >
                                                <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                Loading
                                            </button>
                                        ) : (
                                            <Button
                                                color="primary"
                                                task-title="primary"
                                                className="btn btn-primary btn-sm "
                                                // type="submit"
                                                onClick={() => hadleSubmit()}
                                            >
                                                Submit
                                            </Button>
                                        )}
                                    </div>
                                </Row>
                            </ModalBody>
                        </div>
                    </Modal>


                    <Modal
                        isOpen={remarkModel}
                        toggle={remarkToggle}
                        centered={true}
                        size=""
                        style={{ width: !isMobile ? "300px" : "" }}
                    >
                        <div className="modal-content">
                            <ModalHeader toggle={remarkToggle} tag="h5">
                                Remark
                            </ModalHeader>
                            <ModalBody>
                                Remark: {remark}
                            </ModalBody>
                        </div>
                    </Modal>
                    <Modal
                        isOpen={addRemarkModel}
                        toggle={addRemarkToggle}
                        centered={true}
                        size=""
                        style={{ width: !isMobile ? "500px" : "" }}
                    >
                        <div className="modal-content">
                            <ModalHeader toggle={addRemarkToggle} tag="h5">
                                Remark
                            </ModalHeader>
                            <ModalBody>
                                <div className="">
                                    <Label className="required"> Remark</Label>
                                    <Input
                                        name="remark"
                                        placeholder="Enter Remakrk hear"
                                        type="textarea"
                                        rows={5}
                                        value={remark}
                                        onChange={(e) => { setRemark(e.target.value), setIsRemarkError(false) }}
                                        className="form-control-sm"
                                        invalid={isRemarkError}
                                    />
                                </div>

                                {isRemarkError ? (
                                    <p className="name-required">
                                        {"Please add Remark."}
                                    </p>
                                ) : ''}

                                <Row>
                                    <div className="text-end mt-2">
                                        {formSumitLoading ? (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                            >
                                                <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                Loading
                                            </button>
                                        ) : (
                                            <Button
                                                color="primary"
                                                task-title="primary"
                                                className="btn btn-primary btn-sm "
                                                // type="submit"
                                                onClick={() => hadleSubmitRemark()}
                                            >
                                                Submit
                                            </Button>
                                        )}
                                    </div>
                                </Row>
                            </ModalBody>
                        </div>
                    </Modal>

                </Card>
            </div>
        </div>
    )
}

SendMessage.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
}

export default SendMessage
